import get from 'transmute/get';
export const getAPIEnableWidgetCookieBanner = get('apiEnableWidgetCookieBanner');